import {
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Table,
  Button,
  Center,
  VStack,
} from "@chakra-ui/react";
import Dinero from "dinero.js";
import {
  KYDBatchPayout,
  KYDBatchPayoutItem,
} from "@common/interfaces/KYDOrganization";
import dayjs from "dayjs";

export const PayoutDetailsTable = ({
  payout,
  ...props
}: {
  payout: KYDBatchPayout & {
    events?: Array<KYDBatchPayoutItem & { name?: string }>;
  };
}) => {
  const { events } = payout || {};

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th>Event Name</Th>
          <Th>Event Date</Th>
          <Th textAlign="center">Gross Payout</Th>
          <Th textAlign="center">Hold</Th>
          <Th textAlign="center">Net Payout</Th>
        </Tr>
      </Thead>
      <Tbody>
        {events &&
          events.map((event: KYDBatchPayoutItem & { name?: string }, index) => {
            const isHoldRelease =
              event.hold.amount === 0 && event.payout.amount > 0;
            return (
              <Tr key={index}>
                <Td>
                  <Text>{event.name}</Text>
                </Td>
                <Td>
                  <VStack alignItems="flex-start" gap={1}>
                    <Text>{dayjs(event.start_at).format("MMMM D, YYYY")}</Text>
                    <Text>{dayjs(event.start_at).format("h:mm a")}</Text>
                  </VStack>
                </Td>
                <Td>
                  <Center flexDirection="column">
                    <Text>
                      {Dinero({
                        amount: event.gross.amount,
                        currency: event.gross.currency,
                      }).toFormat() || "-"}
                    </Text>
                    {isHoldRelease ? (
                      <Button
                        variant="outline"
                        size="xs"
                        color="#6DCB24"
                        border="1px solid #D6F0C0"
                        backgroundColor="#E8F7DC"
                        borderRadius="0px"
                        marginTop="8px"
                      >
                        Hold Release
                      </Button>
                    ) : null}
                  </Center>
                </Td>
                <Td>
                  <Center>
                    <Text>
                      {Dinero({
                        amount: event.hold.amount,
                        currency: event.hold.currency,
                      }).toFormat() || "-"}
                    </Text>
                  </Center>
                </Td>
                <Td>
                  <Center>
                    <Text>
                      {Dinero({
                        amount: event.payout.amount,
                        currency: event.payout.currency,
                      }).toFormat() || "-"}
                    </Text>
                  </Center>
                </Td>
              </Tr>
            );
          })}
      </Tbody>
    </Table>
  );
};

export default PayoutDetailsTable;
